import { uniqueId } from 'lodash';
import * as React from 'react';
import { useState } from 'react';
import { ButtonSpinnerSize, type ButtonSpinnerProps } from './types';
import { COLOURS_AA } from '../Colours';

const ButtonSpinner = ({
  size = 'Small',
  color = 'Black',
}: ButtonSpinnerProps) => {
  const [id] = useState(`spinner-${uniqueId()}`);

  const getSize = () => {
    switch (size) {
      case ButtonSpinnerSize.Medium:
        return 32;
      case ButtonSpinnerSize.Large:
        return 52;
      default:
        return 20;
    }
  };

  const sizeValue = getSize();

  const getColor = () => {
    switch (color) {
      case 'Primary':
        return COLOURS_AA.primary.BtnPrimaryDefault;
      case 'White':
        return COLOURS_AA.neutralBG.BgWhite;
      default:
        return 'currentColor';
    }
  };

  const colorValue = getColor();

  return (
    <svg
      id={`${id}51`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      width={sizeValue}
      height={sizeValue}
    >
      <style>
        {`#${id}53_tr {animation: ${id}53_tr__tr 990ms linear infinite normal forwards}@keyframes ${id}53_tr__tr { 0% {transform: translate(12px,12px) rotate(20deg)} 100% {transform: translate(12px,12px) rotate(376.4deg)}} #${id}54_tr {animation: ${id}54_tr__tr 990ms linear infinite normal forwards}@keyframes ${id}54_tr__tr { 0% {transform: translate(12px,12px) rotate(180deg)} 100% {transform: translate(12px,12px) rotate(-176.4deg)}} #${id}55_tr {animation: ${id}55_tr__tr 990ms linear infinite normal forwards}@keyframes ${id}55_tr__tr { 0% {transform: translate(12px,12px) rotate(270deg)} 100% {transform: translate(12px,12px) rotate(626.4deg)}}`}
      </style>
      <defs>
        <linearGradient
          id={`${id}53-stroke`}
          x1="0.316987"
          y1="0.408494"
          x2="0.883982"
          y2="0.969499"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
          color={colorValue}
        >
          <stop id={`${id}53-stroke-0`} offset="0%" stopColor="currentColor" />
          <stop
            id={`${id}53-stroke-1`}
            offset="100%"
            stopColor="currentColor"
            stopOpacity={0}
          />
        </linearGradient>
        <linearGradient
          id={`${id}54-stroke`}
          x1="0.249179"
          y1="0.951459"
          x2="1"
          y2="0.038747"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
          color={colorValue}
        >
          <stop id={`${id}54-stroke-0`} offset="0%" stopColor="currentColor" />
          <stop
            id={`${id}54-stroke-1`}
            offset="100%"
            stopColor="currentColor"
            stopOpacity={0}
          />
        </linearGradient>
        <linearGradient
          id={`${id}55-stroke`}
          x1="0.5"
          y1="1.086121"
          x2="0.829437"
          y2="0.193996"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
          color={colorValue}
        >
          <stop id={`${id}55-stroke-0`} offset="0%" stopColor="currentColor" />
          <stop
            id={`${id}55-stroke-1`}
            offset="100%"
            stopColor="currentColor"
            stopOpacity={0}
          />
        </linearGradient>
      </defs>
      <g id={`${id}53_tr`} transform="translate(12,12) rotate(20)">
        <path
          d="M0.581546,10.581546c-5.522848,0-10-4.477152-10-10s4.477152-10,10-10"
          transform="translate(-0.581546,-0.581546)"
          fill="none"
          stroke={`url(#${id}53-stroke)`}
          strokeWidth="1.5"
        />
      </g>
      <g id={`${id}54_tr`} transform="translate(12,12) rotate(180)">
        <path
          d="M-3.418454,2.581546c-3.313708,0-6-2.686291-6-6s2.686292-6,6-6"
          transform="translate(3.418454,3.418454)"
          fill="none"
          stroke={`url(#${id}54-stroke)`}
          strokeWidth="1.5"
        />
      </g>
      <g id={`${id}55_tr`} transform="translate(12,12) rotate(270)">
        <path
          d="M-6.418454,-3.418454c-1.656854,0-3-1.343145-3-3s1.343146-3,3-3"
          transform="translate(6.418454,6.418454)"
          fill="none"
          stroke={`url(#${id}55-stroke)`}
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
};

export default ButtonSpinner;
